import React, { useState } from "react";
import "../styles/InfoBank.css"; // Import the CSS file

export default function InfoBank() {
  const [isLarge, setIsLarge] = useState(false);

  const toggleQRSize = () => {
    setIsLarge(!isLarge);
  };

  return (
    <div className="info-bank-container">
      <div className="info-bank-detail">
        <p className="account-holder">Etikaf Enterprise</p>

        <h2 className="bank-name">CIMB Bank</h2>
      </div>
      <p className="account-number">8603024519</p>

      {/* QR Code */}
      <div className="qr-container">
        <img
          src="/images/etikaf_qr.png"
          alt="Bank QR Code"
          className={`qr-code ${isLarge ? "large" : ""}`}
          onClick={toggleQRSize}
        />
      </div>
    </div>
  );
}
